import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store";
import App from "./modules/app/App";
import * as serviceWorker from "./serviceWorker";
import 'bootstrap/dist/css/bootstrap.css';
import "./animate.css"
import "../src/styles/css/style.scss";
import "../src/styles/css/style.css";
import "./index.css"
import { CookiesProvider } from 'react-cookie';
import {BrowserRouter } from 'react-router-dom';
// const store = createStore(rootReducer, initialStore);


ReactDOM.render(
  <CookiesProvider>
  <BrowserRouter>
   <Provider store={store}>
    <App />
  </Provider>
  </BrowserRouter>
 </CookiesProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();

 